
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/widget/calendar/[servicePublicIds]",
      function () {
        return require("private-next-pages/[publicId]/widget/calendar/[servicePublicIds]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/widget/calendar/[servicePublicIds]"])
      });
    }
  